import { render, staticRenderFns } from "./LabPreview.vue?vue&type=template&id=182cdf5a&scoped=true&"
import script from "./LabPreview.vue?vue&type=script&lang=js&"
export * from "./LabPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cdf5a",
  null
  
)

export default component.exports